import { render, staticRenderFns } from "./ResWire.vue?vue&type=template&id=34b0c1e9&scoped=true"
import script from "./ResWire.vue?vue&type=script&lang=js"
export * from "./ResWire.vue?vue&type=script&lang=js"
import style0 from "./ResWire.vue?vue&type=style&index=0&id=34b0c1e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b0c1e9",
  null
  
)

export default component.exports